import '../css/add_new_client_page.css'
import React, { useContext, useEffect, useState } from "react";
import { ButtonWIcon, TextInput, MyDatePicker, TextArea } from './Inputs'
import { getStuff, postStuff } from '../helpers/auth'
import { authenticatedContext } from '../App'
import { validateBirthDate } from '../helpers/date_conversion'
import { AlertsContext } from './Layout'
import { useNavigate } from "react-router-dom";
import { MultiplePartDateInput } from './Inputs';

const AddNewClientPage_p1 = () => {
    // Your component logic goes here

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [birthDate, setBirthDate] = useState("")
    const [email, setEmail] = useState("")
    const [telNumber, setTelNumber] = useState("")
    const [cardNumber, setCardNumber] = useState("")
    const [note, setNote] = useState("")

    const [showSave, setShowSave] = useState(false)
    const [errorMess, setErrorMess] = useState(null)

    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);

    const navigate = useNavigate();

    function validate() {
        
        if (!/^[a-zA-Zá-žÁ-Ž]+$/.test(firstName) || !/^[a-zA-Zá-žÁ-Ž]+$/.test(lastName) || firstName.length < 2 || lastName.length < 2) {
            setErrorMess("Neplatné jméno či příjmení");
            return false;
        }
        else if (birthDate.length > 0 && !validateBirthDate(new Date(birthDate))) {
            setErrorMess("Neplatné datum narození");
            return false;
        }
        else if (email.length > 0 && (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email))) {
            setErrorMess("Neplatný email");
            return false;
        }
        else if (telNumber.length > 0 && (!/^\d{9}$/.test(telNumber))) {
            setErrorMess("Neplatné telefonní číslo");
            return false;
        }
        else if (cardNumber.length > 0 && (!/^\d+$/.test(cardNumber))) {
            setErrorMess("Neplatné číslo karty");
            return false;
        }
        else if (note && note.length > 500) {
            setErrorMess("Poznámka je příliš dlouhá.")
            return;
        }
        else {
            setErrorMess("");
            return true;
        }
    }

    useEffect(() => {
        validate();
    }, [firstName, lastName, birthDate, email, telNumber, cardNumber, note])


    function handleNextStepClick(navigateToNextStep = true) {
        if (!validate()) return;
        const data = {
            first_name: firstName,
            last_name: lastName,
            birth_date: birthDate,
            email: email,
            tel_number: telNumber,
            card_number: cardNumber,
            note: note
        }
        console.log("sending data ", data)
        postStuff("create_new_client/", data).then((res) => {
            console.log(res)
            try {
                if (res.status === 200) {
                    //addAlertBanner( "Nový klient byl vytvořen", "success");
                    if(navigateToNextStep)
                        navigate(`/add_new_client/p2/${res.data.client_id}`)
                    else{
                        addAlertBanner("Klient vytvořen!", 'success')
                        window.location.reload(false);
                    }
                } else if (res.status === 400) {
                    if (res.data.error)
                        addAlertBanner("Nepodařilo se vytvořit nového klienta ( " + res.data.error + ")", "warning", 3000);
                    else
                        addAlertBanner("Nepodařilo se vytvořit nového klienta", "danger");
                }
                else if (res.status === 403) {
                    addAlertBanner("Pro vytvoření nového klienta nemáte dostatečné oprávnění")
                } else if (res.status == 401) {
                    setAuthenticated(false);
                }
            } catch (error) {
                addAlertBanner("Nepodařilo se vytvořit nového klienta", "danger");
            }
        })
    }

    return (
        <div className='add-new-client-page'>
            <div className='header'>
                <h1>Vytvoření nového klienta</h1>
                <p>(krok 1/3)</p>
            </div>
            <section className='section-1'>
                <div className='sub-section sub-section-1'>
                    <table className="profile-details">
                        <tbody>
                            <tr>
                                <td className="profile-label">JMÉNO</td>
                                <td className="profile-value">
                                    <TextInput value={firstName} setValue={setFirstName} />
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label">PŘÍJMENÍ</td>
                                <td className="profile-value">
                                    <TextInput value={lastName} setValue={setLastName} />
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label">NAROZENÍ</td>
                                <td className="profile-value">
                                    {/* <MyDatePicker value={birthDate} setValue={setBirthDate} /> */}
                                    <MultiplePartDateInput value={birthDate} setValue={setBirthDate}/>
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label">EMAIL</td>
                                <td className="profile-value">
                                    <TextInput email value={email} setValue={setEmail} />
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label">TELEFON</td>
                                <td className="profile-value">
                                    <TextInput tel value={telNumber} setValue={setTelNumber} />
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label">ČÍSLO KARTY</td>
                                <td className="profile-value">
                                    <TextInput value={cardNumber} setValue={setCardNumber} />
                                </td>
                            </tr>
                            <tr>
                                <td className="profile-label note-td">POZNÁMKA</td>
                            </tr>

                            <tr>
                                <td className="profile-value-note" colSpan="2">
                                    <TextArea value={note} setValue={setNote} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {errorMess != null && <div className="error emes">{errorMess}</div>}


                    <div className='control-bar'>
                    <ButtonWIcon iconSrc={"/img/svg/save_black.svg"} text={"Uložit & začít s dalším"}
                            style={{ backgroundColor: "#29e32698", color: "black" }}
                            onClick={()=>{handleNextStepClick(false)}} />
                        <ButtonWIcon iconSrc={"/img/svg/next.svg"} text={"Uložit & přejít na štítky"}
                            style={{ backgroundColor: "#795BF3", color: "white" }}
                            onClick={handleNextStepClick} />
                    </div>
                </div>
                <div className='sub-section sub-section-2'>

                </div>

            </section>
        </div>
    );
};

export default AddNewClientPage_p1;